import * as React from "react";
import styled from "styled-components";
import Item from "./Item";
import { animated, useSpring } from "react-spring";
import { select } from "@hubper/theme";

const ITEM_WIDTH = 120;

function findActiveIndex(routes: any[], currentPath: string) {
  const activeRoute = routes.find(route => {
    return route.path === "/"
      ? currentPath === "/"
      : currentPath.indexOf(route.path) > -1;
  });
  return routes.indexOf(activeRoute);
}

const Base = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
`;

const ActiveBar = styled(animated.div)`
  position: absolute;
  bottom: 0;
  left: 0;
  width: ${ITEM_WIDTH}px;
  height: 2px;
  background-color: ${select.color(["primary", 5])};
  z-index: 1;
  will-change: transform;
`;

export type ItemProps = {
  title: string;
  path: string;
  openItems?: number;
};

type Props = {
  style?: React.CSSProperties;
  className?: string;
  items: ItemProps[];
  currentPath: string;
  onClick: (path: string) => void;
};

function Navigation(
  { style, className, items, currentPath, onClick }: Props,
  ref: any
) {
  const activeIndex = findActiveIndex(items, currentPath);
  const hasActiveRoute = activeIndex !== -1;

  const activeBarStyle = hasActiveRoute
    ? useSpring({
        transform: `translateX(${activeIndex * ITEM_WIDTH}px)`,
        config: {
          tension: 300,
          clamp: true
        }
      })
    : undefined;

  return (
    <Base ref={ref} style={style} className={className}>
      {items.map((item, index) => (
        <Item
          key={item.path}
          {...item}
          selected={activeIndex === index}
          onClick={onClick}
          style={{ width: ITEM_WIDTH }}
        />
      ))}
      {hasActiveRoute && <ActiveBar style={activeBarStyle} />}
    </Base>
  );
}

export default React.forwardRef(Navigation);
